export default __webpack_public_path__ + "static/Market-study-and-learning-8277821708228863aaafbf28e1666712.webp";